<template>
  <ion-app color="light" :class="currentTheme">
    <!-- Menu partial for every page, check if swipe menu is disabled in route meta -->
    <ion-menu :swipeEnabled="$route.meta?.noSwipeMenu == undefined" content-id="main-content" side="end" color="primary">
      <ion-header color="primary">
        <ion-toolbar color="primary">
          <ion-title>Menu</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content color="primary" class="ion-padding menu-content">
        <ion-list lines="none" color="none" class="menu-list">
          <!-- For every route from menuStore create a navigation item-->
          <!-- Normal menu item -->
          <div class="menuItem" v-for="item in menuStore.menuItems" :key="item.Url">
            <div v-if="!item.SubItems && showMenuItem(item)" color="primary">
              <ion-item @click="handleMenuNavigation(item)" color="primary">
                <i v-if="item.MenuIcon" :class="'menu-icon mdi mdi-24px ' + item.MenuIcon"></i>
                <div v-else class="menu-icon custom-menu-icon" :style="item.Icon ? { 'background-image': getImageUrl(item.Icon) } : {}" />
                <ion-label v-if="item.FromVirtWass">{{ $tm("nav." + item.Tekst) }}</ion-label>
                <ion-label v-else>{{ item.Tekst }}</ion-label>
              </ion-item>
            </div>

            <!-- Sub menu item -->
            <div v-else-if="showMenuItem(item)">
              <ion-accordion-group lines="none" :value="item.Tekst">
                <ion-accordion :value="item.Tekst" :toggle-icon="chevronUpOutline">
                  <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
                  <ion-item lines="none" slot="header" color="primary">
                    <i v-if="item.MenuIcon" :class="'menu-icon mdi mdi-24px ' + item.MenuIcon"></i>
                    <div v-else class="menu-icon custom-menu-icon" :style="item.Icon ? { 'background-image': getImageUrl(item.Icon) } : {}" />
                    <ion-label v-if="item.FromVirtWass">{{ $tm("nav." + item.Tekst) }}</ion-label>
                    <ion-label v-else>{{ item.Tekst }}</ion-label>
                  </ion-item>

                  <!-- Recursive rendering for sub-menu items -->
                  <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
                  <div v-for="subItem in item.SubItems" :key="subItem.Url" slot="content" class="subMenuItem">
                    <!-- Check if subItem has further sub-items -->
                    <ion-item v-if="!subItem.SubItems && showMenuItem(subItem)" lines="none" @click="handleMenuNavigation(subItem)"
                      color="primary" style="padding-left: .5rem; background-color: var(--ion-color-primary);">
                      <i v-if="subItem.MenuIcon" :class="'menu-icon mdi mdi-24px ' + subItem.MenuIcon"></i>
                      <div v-else class="menu-icon custom-menu-icon" :style="subItem.Icon ? { 'background-image': getImageUrl(subItem.Icon) } : {}" />
                      <ion-label v-if="subItem.FromVirtWass">{{ $tm("nav." + subItem.Tekst) }}</ion-label>
                      <ion-label v-else>{{ subItem.Tekst }}</ion-label>
                    </ion-item>

                    <div v-else-if="showMenuItem(subItem)">
                      <ion-accordion-group lines="none"
                        style="padding-left: .5rem; background-color: var(--ion-color-primary);" :value="subItem.Tekst">
                        <ion-accordion :value="subItem.Tekst" :toggle-icon="chevronUpOutline">
                          <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
                          <ion-item lines="none" slot="header" color="primary">
                            <i v-if="subItem.MenuIcon" :class="'menu-icon mdi mdi-24px ' + subItem.MenuIcon"></i>
                            <div v-else class="menu-icon custom-menu-icon" :style="subItem.Icon ? { 'background-image': getImageUrl(subItem.Icon) } : {}" />
                            <ion-label v-if="subItem.FromVirtWass">{{ $tm("nav." + subItem.Tekst) }}</ion-label>
                            <ion-label v-else>{{ subItem.Tekst }}</ion-label>
                          </ion-item>

                          <!-- Recursive sub-items rendering -->
                          <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
                          <div v-for="nestedItem in subItem.SubItems" :key="nestedItem.Url" slot="content"
                            class="subMenuItem">
                            <ion-item v-if="!nestedItem.SubItems && showMenuItem(nestedItem)" lines="none" color="primary"
                              style="padding-left: .5rem; background-color: var(--ion-color-primary);"
                              @click="handleMenuNavigation(nestedItem)">
                              <i v-if="nestedItem.MenuIcon" :class="'menu-icon mdi mdi-24px ' + nestedItem.MenuIcon"></i>
                              <div v-else class="menu-icon custom-menu-icon" :style="nestedItem.Icon ? { 'background-image': getImageUrl(nestedItem.Icon) } : {}" />
                              <ion-label v-if="nestedItem.FromVirtWass">{{ $tm("nav." + nestedItem.Tekst) }}</ion-label>
                              <ion-label v-else>{{ nestedItem.Tekst }}</ion-label>
                            </ion-item>

                            <!-- Recursive component call for deeper levels -->
                            <div v-else-if="showMenuItem(nestedItem)">
                              <ion-accordion-group lines="none"
                                style="padding-left: .5rem; background-color: var(--ion-color-primary);"
                                :value="nestedItem.Tekst">
                                <ion-accordion :value="nestedItem.Tekst" :toggle-icon="chevronUpOutline">
                                  <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
                                  <ion-item lines="none" slot="header" color="primary">
                                    <i v-if="nestedItem.MenuIcon" :class="'menu-icon mdi mdi-24px ' + nestedItem.MenuIcon"></i>
                                    <div v-else class="menu-icon custom-menu-icon" :style="nestedItem.Icon ? { 'background-image': getImageUrl(nestedItem.Icon) } : {}" />
                                    <ion-label v-if="nestedItem.FromVirtWass">{{ $tm("nav." + nestedItem.Tekst) }}</ion-label>
                                    <ion-label v-else>{{ nestedItem.Tekst }}</ion-label>
                                  </ion-item>

                                  <!-- Recursive sub-items rendering -->
                                  <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
                                  <div v-for="menuItem in nestedItem.SubItems" :key="menuItem.Url" slot="content"
                                    class="subMenuItem">
                                    <ion-item v-if="!menuItem.SubItems && showMenuItem(menuItem)" lines="none" color="primary"
                                      style="padding-left: .5rem; background-color: var(--ion-color-primary);"
                                      @click="handleMenuNavigation(menuItem)">
                                      <i v-if="menuItem.MenuIcon" :class="'menu-icon mdi mdi-24px ' + menuItem.MenuIcon"></i>
                                      <div v-else class="menu-icon custom-menu-icon" :style="menuItem.Icon ? { 'background-image': getImageUrl(menuItem.Icon) } : {}" />
                                      <ion-label v-if="menuItem.FromVirtWass">{{ $tm("nav." + menuItem.Tekst) }}</ion-label>
                                      <ion-label v-else>{{ menuItem.Tekst }}</ion-label>
                                    </ion-item>

                                    <!-- Recursive component call for deeper levels -->
                                    <div v-else-if="showMenuItem(menuItem)">
                                      <div :item="menuItem" />
                                    </div>
                                  </div>
                                </ion-accordion>
                              </ion-accordion-group>
                              <!--<div :item="nestedItem" />-->
                            </div>
                          </div>
                        </ion-accordion>
                      </ion-accordion-group>
                    </div>
                  </div>
                </ion-accordion>
              </ion-accordion-group>
            </div>
          </div>


          <!-- If menu items can't be loaded show logout button (probably something wrong with token) -->
          <div v-if="menuStore.menuItems.length == 0" color="primary" class="menuItem">
            <ion-item router-link="/logout" router-direction="root" color="primary">
              <ion-label>Logout</ion-label>
              <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
              <ion-icon slot="start" color="secondary"></ion-icon>
            </ion-item>
          </div>
          <div class="menu-spacer"></div>
          <div class="version-info">
            <ion-item class="version" color="primary">
              <ion-label>Version:</ion-label>
              <ion-label>{{ webportalStore.version }}</ion-label>
            </ion-item>
            <ion-item class="version" color="primary">
              <ion-label>API Version:</ion-label>
              <ion-label>{{ webportalStore.vlApiVersion }}</ion-label>
            </ion-item>
          </div>
        </ion-list>
      </ion-content>
    </ion-menu>
    <!-- Page -->
    <ion-router-outlet id="main-content" :key="$route.path" />
    <!-- Set overlay for loading spinner-->
    <div v-if="feedbackStore.isLoading" class="loading-spinner">
      <img alt="loading spinner" :src="loadingSpinner" />
      <ion-spinner name="crescent" v-if="showSpinner"></ion-spinner>
    </div>
    <my-notifications />
  </ion-app>
</template>

<script lang="ts">
//Import Ionic components and icons
import {
  IonApp,
  IonRouterOutlet,
  IonMenu,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonAccordion,
  IonAccordionGroup,
  IonSpinner,
  menuController,
} from "@ionic/vue";

import { chevronUpOutline } from 'ionicons/icons';

//Import from vue
import { defineComponent, watch } from "vue";
import { useIonRouter } from "@ionic/vue";

import { Network } from "@capacitor/network";

//Import vue components
import MyNotifications from "@/components/MyNotifications.vue";

//Import pinia stores
import { useFeedbackStore } from "@/stores/feedback";
import { useMenuStore } from "@/stores/menu";
import { useOnlineStore } from "@/stores/online";
import { useAuthStore } from "@/stores/auth";

//Import themes and currentTheme from appConfig.ts
import { currentTheme, Theme } from "../appConfig";

//Import Ionic plugins
import { useBluetoothStore } from "@/stores/bluetooth";
import { useScanCommonStore, useScanStore } from "./stores/scan";
import { useWebportalStore } from "./stores/webportal";
import { useLaundryStore } from "./stores/laundry";
import { useDebtorStore } from "./stores/debtor";
import { storeToRefs } from "pinia";
import { MenuItem } from "./models/MenuItem";
import { Capacitor } from '@capacitor/core';
import { updateTranslations } from "./i18n/i18n";

export default defineComponent({
  name: "App",
  //Define all ionic components
  components: {
    MyNotifications,
    IonApp,
    IonRouterOutlet,
    IonMenu,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonIcon,
    IonAccordion,
    IonAccordionGroup,
    IonSpinner
  },
  setup() {
    //Set store
    const feedbackStore = useFeedbackStore();
    const menuStore = useMenuStore();
    const onlineStore = useOnlineStore();
    const webportalStore = useWebportalStore();
    const AuthStore = useAuthStore()

    //Set router
    const router = useIonRouter();

    //Set images
    const images = require.context("@/assets/images/icons", true)

    //Set title and favico according to currentTheme
    const updateFaviconAndTitle = () => {
      const faviconElement = document.querySelector(
        'link[rel="icon"]'
      ) as HTMLLinkElement;
      const titleElement = document.querySelector("title") as HTMLTitleElement;

      if (!faviconElement || !titleElement) {
        return;
      }

      switch (currentTheme) {
        case Theme.VIRTUALLAUNDRY:
          faviconElement.href = require("@/assets/images/favicos/virtuallaundry.png");
          titleElement.textContent = "VL App";
          break;
        case Theme.NEWASCO:
          faviconElement.href = require("@/assets/images/favicos/newasco.png");
          titleElement.textContent = "Newasco App";
          break;
        case Theme.WASMIJNWAS:
          faviconElement.href = require("@/assets/images/favicos/wasmijnwas.png");
          titleElement.textContent = "Wasmijnwas App";
          break;
      }
    };
    updateFaviconAndTitle();

    const common = useScanCommonStore();

    onlineStore.$subscribe((_event, state) => {
      if (state.online) {
        common.active.forEach(([p, s]) => {
          const scanStore = useScanStore(p, s);
          if (!scanStore.isReuploading) {
            scanStore.isReuploading = true;
            scanStore.getVLDateAfterOffline()
              .then(() => scanStore.uploadOfflineQueue())
              .finally(() => {
                scanStore.isReuploading = false;
              });
          }
        })
      }
    });

    const { VLtoken } = storeToRefs(AuthStore);
    watch(VLtoken, async (val) => {
      if (val) {
        await useLaundryStore().getLaundry();
        await useDebtorStore().getDebtors();

        if(Capacitor.getPlatform() == 'web') {
          // Auto-open menu when user logs in (only if not already auto-opened)
          if (!localStorage.getItem('menuAutoOpened')) {
            window.setTimeout(() => {
              menuController.open('end');
              localStorage.setItem('menuAutoOpened', 'true');
            }, 100);
          }
        }
      }
    })

    const handleMenuNavigation = async (item: MenuItem) => {
      // Clear the auto-open flag when user clicks any menu item
      localStorage.removeItem('menuAutoOpened');
      
      if (await menuStore.handleMenuNavigation(item, router)) {
        if(Capacitor.getPlatform() != 'web' || item.Url == "/logout") {
          menuController.close();
        }
      }
    }

    //Return everything to be used in the template
    return { feedbackStore, menuStore, onlineStore, handleMenuNavigation, webportalStore, VLtoken, currentTheme, images, chevronUpOutline };
  },
  async mounted() {
    //Get menuItems
    await useMenuStore().getMenuItems();
    if (this.VLtoken) {
      updateTranslations();
      await useLaundryStore().getLaundry();
      await useDebtorStore().getDebtors();

      if(Capacitor.getPlatform() == 'web') {
        // Open menu by default (always on refresh)
        window.setTimeout(() => {
          menuController.open('end');
        }, 100);
      }
    }

    const checkConnection = async () => {
      const onlineStore = useOnlineStore();
      onlineStore.online = (await Network.getStatus()).connected;
      if (onlineStore.online && onlineStore.sentNoConnectionMessage) {
        onlineStore.sentNoConnectionMessage = false;
      }
    }

    const bluetoothStore = useBluetoothStore();

    await Network.removeAllListeners();
    await Network.addListener("networkStatusChange", checkConnection);

    addEventListener("resume", checkConnection, false)
    addEventListener("resume", bluetoothStore.checkConnection, false)

    setInterval(checkConnection, 3000);
    setInterval(bluetoothStore.checkConnection, 1000);
  },
  computed: {
    loadingSpinner() {
            switch (currentTheme) {
                case Theme.VIRTUALLAUNDRY:
                    return require('@/assets/images/logos/virtuallaundry.png');
                case Theme.NEWASCO:
                    return require("@/assets/images/newasco/newasco_groot.png");
                case Theme.WASMIJNWAS:
                    return require("@/assets/images/wasmijnwas/wasmijnwas_groot.png");
                default:
                    return require('@/assets/images/loadingSpinner.gif');
            }
    },
    showSpinner() {
            switch (currentTheme) {
                case Theme.NEWASCO:
                case Theme.VIRTUALLAUNDRY:
                case Theme.WASMIJNWAS:
                    return true;
                default:
                    return false;
            }
    },
  },
  methods: {
    getImageUrl(url: string) {
      if (url.startsWith('./')) {
        try {
          const image = this.images(url);
          return `url("${image}")`
        } catch {
          return 'unset'
        }
      } else {
        return `url("${url}")`
      }
    },
    showMenuItem(item: MenuItem) {
      if (item.Tekst.toLowerCase().endsWith('wasmijnwas.nl')) {
        return false;
      }
      if (!item.WeergevenInMenu) {
        return false;
      }
      return true;
    }
  }
});
</script>

<style scoped>
.loading-spinner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.loading-spinner img {
  max-width: 50%;
  max-height: 50%;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
}

.loading-spinner ion-spinner {
  margin: 25px;
  height: 35px;
  width: 35px;
}

.md .loading-spinner img {
  max-width: 25%;
  max-height: 25%;
  border-radius: 6%;
}

.bg-transparent {
  background: transparent !important;
}

ion-header {
  background: transparent;
}

.menu-content {
  --padding-top: 0;
  margin-top: 0;
}

/* iOS safe area handling for menu */
@supports (padding: max(0px)) {
  .menu-content {
    padding-top: max(0px, env(safe-area-inset-top));
  }
}

/* Reduce top padding on iOS devices */
.ios .menu-content {
  --padding-top: 0;
}

ion-list {
  background: transparent;
  margin-top: 0;
  padding-top: 0;
}

.menu-list {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.menuItem {
  cursor: pointer;
}

.subMenuItem {
  --background: var(--ion-color-primary-tint);
}

ion-accordion {
  padding: 0px;
}

/* Ensure accordions have proper styling */
ion-accordion {
  --ion-item-background: var(--ion-color-primary);
}

ion-accordion ion-item[slot="header"] {
  --background: var(--ion-color-primary);
}

ion-item ion-label {
  font-size: .8125rem !important;
  font-weight: 500;
  line-height: 1rem;
  font-family: "Roboto", sans-serif !important;
  letter-spacing: normal;
}

ion-item.version {
  height: 32px;
}

ion-item.version ion-label {
  font-size: x-small;
}

.menu-icon {
  margin-right: 12px;
  color: var(--ion-color-secondary) !important;
}

.wasmijnwas .menu-icon {
  color: var(--ion-color-white) !important;
}

.custom-menu-icon {
  height: 24px;
  width: 24px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.menu-spacer {
  margin-bottom: auto;
}
</style>
